import Image from 'next/image'
import { FilterRadio } from './filter-radio'

type Props = {
  value: string
  onFilterChange: (value: string) => void
  underwearList: {
    key: string
    title: string
    image: string
  }[]
}

export const FilterUnderwearStyle = ({
  value,
  onFilterChange,
  underwearList,
}: Props) => {
  return (
    <FilterRadio
      value={value}
      onFilterChange={onFilterChange}
      items={underwearList.map((item) => ({
        value: item.key,
        label: (
          <div className='flex items-center gap-2'>
            <Image src={item.image} alt={item.title} width={20} height={20} />
            {item.title}
          </div>
        ),
      }))}
    />
  )
}
